import React from 'react'
import './index.css'
const LogoLoader = () => {
  return (
    <div>
      <div className='app-loading'>
        <img className='element' src='/logo1.png' alt='logo' />
      </div>
    </div>
  )
}

export default LogoLoader
